import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import axios from 'axios';
import apiClient from './api/client';
import { useCompanies,useUsers } from './hooks';  
import { useCurrentDomain } from "./context/DomainContext";

export default function BulkSMSPage() {
  const { domain } = useCurrentDomain();
  const allowedDomainsForBulkSMS = ['greenyourbills.com'];
  const hasBulkSMSFeature = allowedDomainsForBulkSMS.includes( domain?.toLowerCase() || '');
  const { companies, loading: companiesLoading } = useCompanies(domain);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedSender, setSelectedSender] = useState(null);
  const [messageBody, setMessageBody] = useState('');

  const [isSending, setIsSending] = useState(false);
  const { users, loading: usersLoading } = useUsers(domain, selectedCompany?.value);
  const API_BASE_URL = sessionStorage.getItem("API_BASE_URL");

  const handleSend = async () => {
    if (!selectedCompany?.value) return toast.error("Please select a company");
    if (!selectedSender?.value) return toast.error("Please select a user");
    if (!messageBody.trim()) return toast.error("Message body cannot be empty");

    setIsSending(true);

    try {
      const payload = {
        companyId: selectedCompany.value,
        userId: selectedSender.value,
        messageBody: messageBody.trim()
      };

      // const res = await axios.post(`https://localhost:7053/api/messaging/send-bulk-sms`,
      const res = await apiClient.post('/api/messaging/send-bulk-sms', payload);

      if (res.data.success !== false) {
        toast.success("Bulk SMS request sent successfully!");
        setMessageBody('');
        setSelectedSender(null);
      } else {
        toast.error(res.data.message || "Failed to send bulk SMS");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send bulk SMS");
    } finally {
      setIsSending(false);
    }
  };

  const handleReset = () => {
    setSelectedCompany(null);
    setSelectedSender(null);
    setMessageBody('');
  };

  return (
      <div className="min-vh-100 bg-white">
        <div className="container-fluid pt-1 pb-3 px-3">
          <div className="card shadow border-0">
            <div className="card-body pb-4">
              {!hasBulkSMSFeature && domain && (
                <div className="alert alert-danger mx-3 mt-2 mb-4 py-3 text-center fw-medium">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  The selected domain doesn't have Bulk SMS feature.
                </div>
              )}
              <div className="row g-3 align-items-end">

                <div className="col-md-4">
                  <label className="form-label fw-semibold small mb-1 fs-7">Company</label>
                  <Select
                    options={companies}
                    value={selectedCompany}
                    onChange={setSelectedCompany}
                    placeholder="Select company..."
                    isClearable
                    isSearchable
                    isDisabled={companiesLoading || !hasBulkSMSFeature}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={{
                      control: (base) => ({ ...base, minHeight: '34px', height: '34px', fontSize: '13px' }),
                    }}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold small mb-1">User</label>
                  <Select
                    options={users}
                    value={selectedSender}
                    onChange={setSelectedSender}
                    placeholder={selectedCompany ? "Select user..." : "Select company first"}
                    isClearable
                    isSearchable
                    isLoading={usersLoading}
                    isDisabled={!selectedCompany || usersLoading || !hasBulkSMSFeature}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={{
                      control: (base) => ({ ...base, minHeight: '34px', height: '34px', fontSize: '13px' }),
                    }}
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold small mb-1">Message Body</label>
                  <textarea
                    className="form-control"
                    rows={6}
                    value={messageBody}
                    onChange={(e) => setMessageBody(e.target.value)}
                    placeholder="Type your message here..."
                    style={{ fontSize: '13px', resize: 'vertical' }}
                  />
                </div>

                <div className="col-12 d-flex justify-content-end gap-2 mt-2">
                  <button className="btn btn-secondary btn-sm px-2" onClick={handleReset} disabled={isSending}>
                    Reset
                  </button>

                  <button
                    className="btn text-white px-2"
                    style={{ backgroundColor: '#0aa375', border: 'none' }}
                    onClick={handleSend}
                    disabled={isSending || !selectedCompany || !selectedSender || !messageBody.trim() || !hasBulkSMSFeature}
                  >
                    {isSending ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Sending...
                      </>
                    ) : (
                      'Send'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}